export default class Utils {
  /**
   * Wraps a jQuery event binding in a promise that resolves when the event is triggered.
   * Maybe be optionally aborted by passing and using an AbortSignal.
   */
  static promisifyEvent(elem, event, abortSignal = null) {
    const $elem = elem instanceof jQuery ? elem : $(elem);

    if (abortSignal && abortSignal.aborted) {
      return Promise.reject(new Error("Aborted"));
    }

    return new Promise((resolve, reject) => {
      if (abortSignal) {
        abortSignal.addEventListener("abort", () => {
          reject(new Error("Aborted"));
        });
      }

      const handler = (e, data) => {
        resolve(data);
      };

      // Force a single binding by unbinding first
      $elem.off(event, handler).on(event, handler);
    });
  }

  /**
   * Races the given promise against a timeout of the specified milliseconds.
   * If the promise takes longer to resolve, then it times out and the promise is rejected.
   * @param {Promise} promise
   * @param {Number} ms
   * @returns A promise which resolves with the result of the given promise,
   *          or rejects if the time out is reached.
   */
  static timeout(promise, ms) {
    let timer;
    return Promise.race([
      promise,
      // eslint-disable-next-line no-promise-executor-return
      new Promise((_, reject) => setTimeout(reject, ms, `Timed out after ${ms} ms.`)),
    ]).finally(() => clearTimeout(timer));
  }

  /**
   * Returns a copy of the string with the first letter of each word capitalised.
   * @param {string} str the string to convert
   * @returns the converted string
   */
  static titleCase = function (str) {
    return str.replace(/(^|\s)\S/g, function (t) { return t.toUpperCase() });
  }
}
